module.exports = __webpack_public_path__ + "static/home-898b0b5540ccdc3ed1e54fed03ddefe6.jpg";